{
  "version": 1,
  "asset_id": "c78b34a2-1304-404c-8a34-94efb7144ff5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/c78b34a2-1304-404c-8a34-94efb7144ff5/sleeve-ugi-reflux-post-736-736.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/c78b34a2-1304-404c-8a34-94efb7144ff5/sleeve-ugi-reflux-post-736-736.webp",
  "original_filename": "sleeve-ugi-reflux-post-736-736.webp",
  "size": 36062,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:13:39Z"
}
